import React from "react";
import { useEffect,useState } from "react";
import classes from './AboutUs.module.css';
import Svg1 from "../../ExplorerClub/Svg1";
import Svg2 from "../../ExplorerClub/Svg2";
import Svg3 from "../../ExplorerClub/Svg3";
import Svg4 from "../../ExplorerClub/Svg4";
import Svg5 from "../../ExplorerClub/Svg5";
import Svg6 from "../../ExplorerClub/Svg6";

const AboutUs = () => {
    const [deviceWidth,setDeviceWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            console.log(window.innerWidth)
          setDeviceWidth(window.innerWidth);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);
    return (
        <>
        <img className={classes['entry-img']} src="https://static.wixstatic.com/media/da937f_3ce6d8bd31da4b2b8fd7a77693fe5ac6~mv2.webp" alt="" />     
        <div>
            <p className={classes['explore-heading']}>Explore <span className={classes['explore-heading']} style={{color:"#e65439"}}>Us</span></p>
            <p className={classes['explore-desc']}>Discover a world of wanderlust with Exploro. Driven by our passion for exploring new destinations and discovering the world, we bring you experimental travel experiences, handpicked by the top travel influencers. Join the exclusive Exploro Club and connect with a community of like-minded travellers who are ready to take on the world.</p>
            <p className={classes['join-club']}>Join the Journey Club</p>
            <div className={classes['grid-perks']}>
                <Svg1 />      
                <Svg2 />
                <Svg3 />
                <Svg4 />
                <Svg5 />
                <Svg6 />
            </div>
            <p className={classes['our-team-text']}>
                Our Team
            </p>
            <div className={classes['our-team-container']}>
                <div className={classes['member-container']} style={{display:"flex",flexDirection:"column"}}>
                    <p className={classes['member-name']}>Anirudh Goel</p>
                    <p className={classes['member-info']}>Anirudh Goel, was a full-time business consultant and a part-time traveller before embarking on his journey with Exploro. With an engineering degree from Delhi Technological University, Anirudh's passion for travel has been evident since his college days. He loves to explore both solo and in groups, capturing the beauty of nature through his lens and penning poetry to accompany his stunning photographs. Anirudh is a firm believer in the power of a good bucket list and is constantly ticking off destinations, one adventure at a time.</p>
                </div>
                <img className={classes['member-photo']} src="https://static.wixstatic.com/media/da937f_7bb938652bd94caeaca4a0bad16f7c57~mv2.jpg" alt="" />
            </div>
            <div className={classes['our-team-container-2']} style={{flexDirection:`${deviceWidth>768?"row-reverse":""}`}}>
                <div className={classes['member-container']} style={{display:"flex",flexDirection:"column"}}>
                    <p className={classes['member-name']}>Mukul Kundra</p>
                    <p className={classes['member-info']}>Mukul Kundra, is a published author with several bestsellers to his name, including "The Interview" and "How Old are You." After completing his engineering from Delhi Technological University, Mukul pursued a career in product management before dedicating himself to Exploro. Mukul has a passion for fitness and loves to chase sunsets during his travels. With his unique blend of creativity and business acumen, Mukul is a driving force behind our mission to revolutionize the travel industry.</p>
                </div>
                <img className={classes['member-photo']} src="https://static.wixstatic.com/media/da937f_6b9b1e9c4c484ea084a8a05c34966969~mv2.jpg" alt="" />
            </div>
        </div>   
        </>
    )
};

export default AboutUs;